import { render, staticRenderFns } from "./TaxiDetails.vue?vue&type=template&id=77eeb7c4"
import script from "./TaxiDetails.vue?vue&type=script&lang=js"
export * from "./TaxiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports